import React, { FC } from 'react';
import { TypeCtaWithTrailingTextFields } from '@/core/generated-types';
import { UniversalCta } from '../UniversalCta';
import classNames from 'classnames';

interface CTAWithTrailingTextProps extends TypeCtaWithTrailingTextFields {
  className?: string;
  isCenterAligned?: boolean;
}

const CTAWithTrailingText: FC<CTAWithTrailingTextProps> = ({
  entryName,
  cta,
  trailingText,
  className,
  isCenterAligned = true,
}) => {
  return (
    <div
      data-testid={`cta-with-trailing-text-${entryName}`}
      className={classNames('flex flex-col', isCenterAligned && 'w-full')}
    >
      <UniversalCta
        link={cta}
        className={`mx-auto w-full md:w-auto ${className}`}
      />
      <div
        className={classNames(
          'mt-4 text-d-sm',
          isCenterAligned ? 'text-center' : 'text-left',
        )}
      >
        {trailingText}
      </div>
    </div>
  );
};

export default React.memo(CTAWithTrailingText);
